module.exports = __webpack_public_path__ + "static/media/logo-vc-horizontal.06a69e25.svg";